import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, className, ...props }) => {
  let IconComponent;
  try {
    IconComponent = icon || (name && FiIcons[`Fi${name}`]);
  } catch (e) {
    IconComponent = null;
  }
  
  return IconComponent ? (
    <IconComponent className={className} {...props} />
  ) : (
    <FiAlertTriangle className={`text-yellow-500 ${className}`} {...props} />
  );
};

export default SafeIcon;